<template>
  <div v-if="providers?.length">
    <form
      ref="form"
      method="POST"
      :action="action"
      novalidate
      @submit.prevent
    />

    <div class="sso">
      <template
        v-for="({ id, name, component_path }) in providers"
        :key="`sso_${id}`"
      >
        <app-component-loader
          :component-path="component_path"
          :objects="{ provider: name, isLoading: provider_id === id }"
          @click="handleClickSsoButton(id)"
        />
      </template>
    </div>

    <span
      class="align--center d-block color--vlg margin__t--18"
      v-if="allowedAuthenticationForm"
    >
      {{ t('literal.or').toLowerCase() }}
    </span>
  </div>
</template>

<script setup>
import { ref, computed, nextTick, defineAsyncComponent } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { storeToRefs } from 'pinia'
import { useSsoStore } from '@/stores/SsoStore'
import { useI18n } from '@/vendors/i18n'
import { useAllowedFeatures } from '@/composables/app/useAllowedFeatures'

const AppComponentLoader = defineAsyncComponent(() => import('&/atoms/AppComponentLoader'))

const { resolve } = useRouter()
const { fullPath } = useRoute()
const { t } = useI18n()
const { allowedAuthenticationForm } = useAllowedFeatures()
const { getProviders } = useSsoStore()
const { loader } = storeToRefs(useSsoStore())

const { providers } = getProviders()

const form = ref()
const provider_id = ref()

const route = computed(() => resolve({ name: 'SsoExchange', query: { return_url: fullPath } }))
const redirectUrl = computed(() => encodeURIComponent(window.location.origin + route.value.href))
const action = computed(() => `${process.env.VUE_APP_ROOT_API}/auth/sso/${provider_id.value}?redirect_url=${redirectUrl.value}`)

const handleClickSsoButton = id => {
  if (!id) return

  loader.value = true
  provider_id.value = id

  nextTick(() => form.value?.submit())
}
</script>

<style lang="scss" scoped>
.sso {
  & > .btn {
    &:not(:last-child) {
      margin-bottom: 18px;
    }
  }
}
</style>